// Initial form state shape for the wedding submission form.
export const initialSubmissionData = {
  // Basic Details
  name: '',
  age: '',
  occupation: '',
  partnerName: '',
  partnerAge: '',
  partnerOccupation: '',
  email: '',
  phone: '',
  weddingDate: '',
  weddingLocation: '',

  // Love Story
  howMet: '',
  whyNow: '',
  themeVibe: '',
  invitationIdeas: '',

  // Ceremony
  ceremonySpot: '',
  fashionMoment: '',
  bouquet: '',
  rings: '',
  ceremonySpecial: '',

  // Celebration
  venueDetails: '',
  decorDreams: '',
  menuDetails: '',
  entertainment: '',
  firstDance: '',
  dreamTeam: '',

  // Special Moments
  petAppearance: '',
  mishapsSurprises: '',
  unconventionalChoices: '',
  aboveAndBeyond: '',

  // Suppliers
  venue: '',
  photographer: '',
  videographer: '',
  dressDesigner: '',
  suitDesigner: '',
  hairStylist: '',
  makeupArtist: '',
  flowers: '',
  cake: '',
  catering: '',
  decorStyling: '',
  entertainmentSupplier: '',
  celebrant: '',
  stationery: '',
  transport: '',

  // Additional
  additionalInfo: '',
};

// Supplier list rendered as a 2-col grid of <Input>s.
export const supplierFields = [
  { name: 'venue', label: 'Venue' },
  { name: 'photographer', label: 'Photographer' },
  { name: 'videographer', label: 'Videographer' },
  { name: 'dressDesigner', label: 'Dress Designer' },
  { name: 'suitDesigner', label: 'Suit Designer' },
  { name: 'hairStylist', label: 'Hair Stylist' },
  { name: 'makeupArtist', label: 'Makeup Artist' },
  { name: 'flowers', label: 'Flowers' },
  { name: 'cake', label: 'Cake' },
  { name: 'catering', label: 'Catering' },
  { name: 'decorStyling', label: 'Decor/Styling' },
  { name: 'entertainmentSupplier', label: 'Entertainment' },
  { name: 'celebrant', label: 'Celebrant' },
  { name: 'stationery', label: 'Stationery' },
  { name: 'transport', label: 'Transport' },
];

// Builds a plain-text submission body from form values
// for the /api/contacts message field.
export const buildSubmissionContent = (data) => `
WEDDING STORY SUBMISSION

=== COUPLE DETAILS ===
Name: ${data.name}, Age: ${data.age}
Occupation: ${data.occupation}
Partner: ${data.partnerName}, Age: ${data.partnerAge}
Partner Occupation: ${data.partnerOccupation}
Email: ${data.email}
Phone: ${data.phone}
Wedding Date: ${data.weddingDate}
Location: ${data.weddingLocation}

=== LOVE STORY ===
How They Met: ${data.howMet}
Why Now: ${data.whyNow}
Theme/Vibe: ${data.themeVibe}
Invitation Ideas: ${data.invitationIdeas}

=== CEREMONY ===
Ceremony Spot: ${data.ceremonySpot}
Fashion Moment: ${data.fashionMoment}
Bouquet: ${data.bouquet}
Rings Story: ${data.rings}
Special Touches: ${data.ceremonySpecial}

=== CELEBRATION ===
Venue Details: ${data.venueDetails}
Decor Dreams: ${data.decorDreams}
Menu: ${data.menuDetails}
Entertainment: ${data.entertainment}
First Dance: ${data.firstDance}
Dream Team: ${data.dreamTeam}

=== SPECIAL MOMENTS ===
Pet Appearance: ${data.petAppearance}
Mishaps/Surprises: ${data.mishapsSurprises}
Unconventional Choices: ${data.unconventionalChoices}
Above & Beyond: ${data.aboveAndBeyond}

=== SUPPLIERS ===
Venue: ${data.venue}
Photographer: ${data.photographer}
Videographer: ${data.videographer}
Dress Designer: ${data.dressDesigner}
Suit Designer: ${data.suitDesigner}
Hair Stylist: ${data.hairStylist}
Makeup Artist: ${data.makeupArtist}
Flowers: ${data.flowers}
Cake: ${data.cake}
Catering: ${data.catering}
Decor/Styling: ${data.decorStyling}
Entertainment: ${data.entertainmentSupplier}
Celebrant: ${data.celebrant}
Stationery: ${data.stationery}
Transport: ${data.transport}

=== ADDITIONAL INFO ===
${data.additionalInfo}
`;
